import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import { FlotiqApi } from "@jti/rest-api";
import { useConfig } from "../../providers/useConfig";
import { useTranslations } from "../../providers/useTranslations";
import { VerticalLoader } from "../VerticalLoader";
import { StoreDetailsMap } from "./components";
import styles from "./StoreDetails.module.scss";
const getStoreDetailsDataFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    const entries = Array.from(params.entries());
    return Object.fromEntries(entries.map(([key, value]) => [key, value === "true" || value === "false" ? Boolean(value) : value]));
};
export const StoreDetails = ({ storeIcons }) => {
    const { __ } = useTranslations();
    const { locationServiceMapProvider } = useConfig();
    const [storeDetails, setStoreDetails] = useState();
    const isHeaderAddressVisible = locationServiceMapProvider !== "naver";
    const updateStoreLocatorData = useCallback(async () => {
        const storeDetailsDataFromUrl = getStoreDetailsDataFromUrl();
        const flotiqApi = FlotiqApi.init();
        const store = await flotiqApi.getStoreById(storeDetailsDataFromUrl.shopId);
        const { Street, City, ZipCode } = store;
        const address = [Street, City, ZipCode].filter(Boolean).join(", ");
        setStoreDetails({
            store: { ...store, address },
            isOpeningHoursEnabled: storeDetailsDataFromUrl.isOpeningHoursEnabled,
            isOpeningHoursBreaksEnabled: storeDetailsDataFromUrl.isOpeningHoursBreaksEnabled,
            isAvailableDevicesEnabled: storeDetailsDataFromUrl.isAvailableDevicesEnabled,
            isAvailableSticksEnabled: storeDetailsDataFromUrl.isAvailableSticksEnabled,
        });
    }, [setStoreDetails]);
    useEffect(() => {
        let ignore = false;
        if (!ignore) {
            updateStoreLocatorData();
        }
        return () => {
            ignore = true;
        };
    }, [updateStoreLocatorData]);
    if (!storeDetails) {
        return _jsx(VerticalLoader, { className: styles.loaderContainer, dataTestId: "storeDetailsLoader" });
    }
    return (_jsxs("div", { className: styles.storeDetailsContainer, children: [isHeaderAddressVisible && (_jsxs("div", { className: styles.headerWrapper, children: [_jsx("div", { className: styles.headerSpacer }), _jsx("div", { className: styles.headerRight, children: _jsxs("h1", { className: styles.storeDetailsHeadline, children: [storeDetails.store.StoreName, " ", storeDetails.store.Street] }) })] })), _jsx("div", { className: styles.storeMapContainer, children: _jsx(StoreDetailsMap, { storeIcons: storeIcons, ...storeDetails }) })] }));
};
//# sourceMappingURL=StoreDetails.js.map